import { createStore } from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'

export default createStore({
	state: {
		user: {},
		clients: [],
		client: null,
		contacts: [],
		contact: null,
		expoName: "",
		sources: [],
		source: null,
		resume: "",
		companyInfo: {},
		companyInfoLoading: false
	},
	getters: {
	},
	mutations: {
		setUser: (state,payload) => {
			state.user = payload
		},
		setSources: (state,payload) => {
			state.sources = payload
		},
		setClients: (state,payload) => {
			state.clients = payload
		},
		setContacts: (state,payload) => {
			payload.unshift({ID:'new', LAST_NAME:'Добавить', NAME:'новый'})
			payload.forEach((element) => {
				element.search = element.LAST_NAME+element.NAME
			})
			state.contacts = payload
			state.contact = null
		},
		setResume: (state,payload) => {
			state.resume = payload
		},
		setCompanyInfo: (state,payload) => {
			state.companyInfo = payload
			state.companyInfoLoading = false
		},
		setCompanyInfoLoading: (state,payload) => {
			state.companyInfoLoading = payload
		}
	},
	actions: {
		getSources: (context,payload) => {
			axios
			.get('https://expob24.9330077.ru/getSources.php')
			.then(function (response) {
				context.commit('setSources',response.data)
			})
		},
		getClients: (context,payload) => {
			axios
			.get('https://expob24.9330077.ru/getB24Clients.php')
			.then(function (response) {
				context.commit('setClients',response.data)
			})
		},
		getCompanyInfo(context,payload){
			context.commit('setCompanyInfoLoading',true)
			axios
			.get('https://expob24.9330077.ru/getCompanyInfo.php?id='+this.state.client.ID)
			.then(function (response) {
				context.commit('setCompanyInfo',response.data)
			})
		},
	},
	modules: {
	}
})
